import React from "react";

type LabelVariant =
	| "header"
	| "subheader"
	| "text_lg"
	| "text_md"
	| "text_sm"
	| "text_xs";

interface ILabelProps {
	text: string; // The label's text
	variant?: LabelVariant; // The variant for the label
	color?: string; // Tailwind text color classes, e.g., 'text-gray-800'
	className?: string; // Additional custom classes
}

const Label: React.FC<ILabelProps> = ({
	text,
	variant = "text_md", // Default to "text" variant
	color = "text-gray-800", // Default color
	className = "",
}) => {
	// Define styles for each variant
	const variantStyles: Record<LabelVariant, string> = {
		header: "text-2xl font-Poppins font-bold",
		subheader: "text-lg font-Poppins font-semibold",
		text_lg: "text-base font-Poppins font-normal text-lg",
		text_md: "text-base font-Poppins font-normal text-md",
		text_sm: "text-base font-Poppins font-normal text-sm",
		text_xs: "text-base font-Poppins font-normal text-xs",
	};

	return (
		<span
			className={`${variantStyles[variant]} ${color} ${className} tracking-wide text-center `}
		>
			{text}
		</span>
	);
};

export default Label;
